import React, { Component } from 'react';
import instagramLogo from '../../../assets/instagram.png';

const singleProud = (props) => {
    const instaUrl = 'http://instagram.com/' + props.instagram;
    let stylise;
    if(props.main){
        stylise = 'proud-dominik'
    } else {
       stylise = 'proud-single'
    }
    let pride = (
      <div className={stylise}>
          <div className="container">
          <div className="row">
          <div className="col-md-10"><h2>{props.instagram ? <a href={instaUrl}><img className="img-fluid" src={instagramLogo} /></a> : null} {props.name} is proud of...</h2></div></div></div>
          <p>{props.content}</p>
      </div>
    )
  return pride;
}

export default singleProud;


// WEBPACK FOOTER //
// ./src/MainContainer/ShowPride/SingleProud/SingleProud.js